import { Flex, Table, Text } from '@radix-ui/themes'
import type { TRPCOutputs } from '~/utils/trpc'
import { StationTypeIcon } from '~/features/stations/components/StationTypeIcon'
import { CellText } from '~/components/CellText'
import { TabState } from '~/components/TabState'

type Station = TRPCOutputs['ops']['stations']['list']['stations'][number]

interface OrgStationsTabProps {
  stations: Station[]
  total: number
  loading: boolean
  error: string | null
  onRowClick: (stationId: string) => void
}

export const OrgStationsTab = ({ stations, total, loading, error, onRowClick }: OrgStationsTabProps) => (
  <TabState
    loading={loading}
    error={error}
    isEmpty={stations.length === 0}
    emptyMessage="No stations for this organization."
  >
    <Flex direction="column" gap="2">
      {stations.length < total && (
        <Text size="1" color="amber">
          Showing {stations.length} of {total} stations — open the fleet directory to page through the rest.
        </Text>
      )}
      <Table.Root variant="surface">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell width="40px">
              <span className="sr-only">Type</span>
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Name</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Site</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Internal ID</Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {stations.map((station) => (
            <Table.Row
              key={station.id}
              onClick={() => onRowClick(station.id)}
              className="cursor-pointer hover:bg-[var(--gray-a2)]"
            >
              <Table.Cell>
                <StationTypeIcon measurementType={station.measurement_type} stationType={station.station_type} />
              </Table.Cell>
              <Table.Cell>
                <Text size="2">{station.name}</Text>
              </Table.Cell>
              <Table.Cell>
                <Text size="2">{station.site.name}</Text>
              </Table.Cell>
              <Table.Cell>
                <CellText value={station.internal_id} mono />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Flex>
  </TabState>
)
